import AceEditor from "react-ace";
import "ace-builds/src-noconflict/mode-javascript";
import "ace-builds/src-noconflict/mode-html";
import "ace-builds/src-noconflict/mode-css";
import "ace-builds/src-noconflict/theme-monokai";
export const FormulaireHTML5 = () =>{

    function calcHeight(nbLine){
        let calc = 19*nbLine
        return calc+"px"
        }
        
    return(
    
        <div id="articleContent" className="formulaireHTML5">

<h2>Résumé des champs de formulaire HTML5</h2>

            <pre>
                <code>
                <AceEditor
                    fontSize={16}
                    showPrintMargin={false}
                    showGutter= {true}
                    mode="html"
                    theme="monokai"
                    value={`<form method="post" action="traitement.php">
    <!--/////////////////////// INPUT TEXT //////////////////////////-->
    <label for="pseudo">Input de type texte</label> :
    <input type="text" name="pseudo" id="pseudo" size="20rem" 
    minlength="10" maxlength="20" value="préremplissage" 
    placeholder="Veillez saisir votre pseudo" required autofocus /><br>
    <!--/////////////////////// INPUT TEXT avec pattern//////////////-->
    <label for="pseudo2">Input de type texte avec un pattern</label> :
    <input type="text" id="pseudo2" pattern="[A-Za-z]{3}" title="3 lettres" /><br>
    <!--/////////////////////// INPUT PASSWORD //////////////////////////-->  
    <label for="password">Input de type password</label> :
    <input type="password" id="password" 
    pattern="^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$" title="Regex" /><br>
    <!--/////////////////////// TEXTAREA //////////////////////////-->     
    <textarea cols="30" rows="10">Le contenu du textarea lorem ipsum</textarea><br>
    <!--/////////////////////// CHECKBOX //////////////////////////-->  
    <input type="checkbox" name="checkbox1" id="checkbox1" checked />
    <label for="checkbox1">checkbox 1</label><br />
    <input type="checkbox" name="checkbox2" id="checkbox2" />
    <label for="checkbox2">checkbox 2</label><br />
    <input type="checkbox" name="checkbox3" id="checkbox3" />
    <label for="checkbox3">checkbox 3</label><br />
    <input type="checkbox" name="checkbox4" id="checkbox4" />
    <label for="checkbox4">checkbox 4</label>
    <!--/////////////////////// RADIO //////////////////////////-->      
    <input type="radio" name="age" value="radio1" id="radio1" />
    <label for="radio1">Radio 1</label><br />
    <input type="radio" name="age" value="radio2" id="radio2" checked />
    <label for="radio2">Radio 2</label><br />
    <input type="radio" name="age" value="radio3" id="radio3" />
    <label for="radio3">Radio 3</label><br />
    <input type="radio" name="age" value="radio4" id="radio4" />
    <label for="radio4">Radio 4</label>
    <!--/////////////////////// SELECT //////////////////////////-->      
    <label for="select">Dans quel pays habitez-vous ?</label><br />
    <select name="select" id="select">
        <option value="" disabled selected>Sélectionner une option</option>
        <optgroup label="Optgroup">
            <option value="choice1">Choice 1</option>
            <option value="choice2">Choice 2</option>
            <option value="choice3">Choice 3</option>
            <option value="choice4">Choice 4</option>
        </optgroup>
        <optgroup label="Optgroup">
            <option value="choice5">Choice 5</option>
            <option value="choice6">Choice 6</option>
        </optgroup>
        <optgroup label="Optgroup">
            <option value="choice7">Choice 7</option>
            <option value="choice8">Choice 8</option>
        </optgroup>
    </select><br>
    <!--/////////////////////// EMAIL //////////////////////////-->      
    <label for="email">Input de type email</label> :
    <input type="email" id="email" required /><br>
    <!--/////////////////////// URL //////////////////////////-->      
    <label for="url">Input de type url</label> :
    <input type="url" id="url" required /><br>
    <!--/////////////////////// TEL //////////////////////////-->      
    <label for="tel">Input de type tel</label> :
    <input type="tel" id="tel" required /><br>
    <!--/////////////////////// NUMBER //////////////////////////-->      
    <label for="number">Input de type number</label> :
    <input type="number" id="number" min="5" max="20" step="2" required /><br>
    <!--/////////////////////// RANGE //////////////////////////      
    <label for="range">Input de type curseur</label> :
    <input type="range" id="range" min="0" max="20" step="5" required /><br>
    <!--/////////////////////// COLOR //////////////////////////-->      
    <label for="color">Input de type color</label> :
    <input type="color" id="color" required /><br>
    <!--/////////////////////// DATE //////////////////////////-->      
    <label for="date">Input de type date</label> :
    <input type="date" id="date" required /><br>
    <!--/////////////////////// SEARCH //////////////////////////-->      
    <label for="search">Input de type search</label> :
    <input type="search" id="search" required /><br>
    /////////////////////// BUTTON SUBMIT //////////////////////////-->      
    <input type="submit" value="button de type submit" />
    <!--/////////////////////// BUTTON RESET //////////////////////////-->      
    <input type="reset" value="button de type reset" />
</form>`}
                    height={calcHeight(81)}
                    width="100%"
                  />
                </code>
                </pre>
                <h2>Les champs de formulaire HTML5 en détails</h2>
                <form method="post" action="traitement.php">

                <div className="border">
                            <p>Tips</p>
                            <div>
                                <div>
                                    <ul className="coursForm">
                                        <li><strong className="highlight">fieldset + legend</strong> est utilisé afin de regrouper plusieurs contrôles interactifs ainsi que des étiquettes dans un formulaire web.</li>
                                        <li><strong className="highlight">tabindex = "0"</strong> est un entier indiquant si l'élément peut capturer le focus et si c'est le cas, dans quel ordre il le capture lors de la navigation au clavier (généralement à l'aide de la touche Tab).</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="border">
                            <p>input[type="text"]</p>
                            <div>
                                <label for="pseudo">Input de type texte</label> :
                                <input type="text" name="pseudo" id="pseudo" size="20rem" minlength="10" maxlength="20"
                                    value="préremplissage" placeholder="Veillez saisir votre pseudo" required
                                    autofocus />
                            </div>
                            <pre>
                <code>
                <AceEditor
                    fontSize={16}
                    showPrintMargin={false}
                    showGutter= {true}
                    mode="html"
                    theme="monokai"
                    value={`<label for="pseudo">Input de type texte</label>
<input type="text" name="pseudo" id="pseudo" size="20rem"  minlength="10"
 maxlength="20" value="préremp" placeholder="Votre pseudo" required autofocus/>`}
                    height={calcHeight(3)}
                    width="100%"
                  />
                </code>
                </pre>
                            <ul className="coursForm">
                                <li><strong className="highlight">name</strong> sera utilisé pour le traitement php</li>
                                <li><strong className="highlight">for</strong> sur le label pour liée le label l'<strong
                                        className="highlight">id</strong> de l'input</li>
                                <li><strong className="highlight">size</strong> permet de définir une longueur au champs
                                </li>
                                <li><strong className="highlight">maxlength</strong> et <strong
                                        className="highlight">minlenght</strong> pour limiter le nombre de caractères saisi
                                </li>
                                <li><strong className="highlight">value</strong> pour préremplir le champ</li>
                                <li><strong className="highlight">placeholder</strong> pour donner une indication sur le
                                    contenu du champ</li>
                                <li><strong className="highlight">required</strong> rend le champ obligatoire</li>
                                <li><strong className="highlight">autofocus</strong> pour placer automatiquement le curseur
                                    dans l'un des champs du formulaire</li>
                            </ul>
                            <div>
                                <div>
                                    <label for="pseudo">Input de type texte avec un pattern</label> :
                                    <input type="text" pattern={'[A-Za-z]{3}'} title="3 lettres" />
                                 
                 <pre>
                <code>
                <AceEditor
                    fontSize={16}
                    showPrintMargin={false}
                    showGutter= {true}
                    mode="html"
                    theme="monokai"
                    value={`<input type="text" pattern=[A-Za-z]{3}  title="3 lettres"/>`}
                    height={calcHeight(1)}
                    width="100%"
                  />
                </code>
                </pre>

                                </div>
                                <div>
                                    <ul>
                                        <li><strong className="highlight">pattern</strong> pour ajouter une expression
                                            régulière</li>
                                        <li><strong className="highlight">title</strong> pour donner des indications sur le
                                            format de la saisie</li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                        <div class="border">
                            <p>input[type="password"]</p>
                            <div>
                                <div>
                                    <label for="password">Input de type password</label> :
                                    <input type="password" id="password"
                                        pattern="^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$" title="Regex" />

                                    <pre>
                <code>
                <AceEditor
                    fontSize={16}
                    showPrintMargin={false}
                    showGutter= {true}
                    mode="html"
                    theme="monokai"
                    value={`<input type="password" id="password" pattern="^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$" title="Regex" required/>`}
                    height={calcHeight(1)}
                    width="100%"
                  />
                </code>
                </pre>




                                    <ul class="coursForm">
                                        <li>Minimum huit caractère, au moins une lettre et un chiffre : <strong
                                                class="highlight">{'^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$'}</strong></li>
                                        <li>Minimum huit caractères, au moins une lettre, un chiffre et un caractère
                                            spécial : <strong
                                                class="highlight">{'^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$'}</strong>
                                        </li>
                                        <li>Minimum huit caractères, au moins une lettre majuscule, une lettre minuscule
                                            et un chiffre : <strong
                                                class="highlight">{'^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{8,}$'}</strong>
                                        </li>
                                        <li>Minimum huit caractères, au moins une lettre majuscule, une lettre
                                            minuscule, un chiffre et un caractère spécial : <strong
                                                class="highlight">{'^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$'}</strong>
                                        </li>
                                        <li>Minimum huit et maximum 10 caractères, au moins une lettre majuscule, une
                                            lettre minuscule, un chiffre et un caractère spécial : <strong
                                                class="highlight">{'^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,10}$'}</strong>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>



                        <div class="border">
                            <p>textarea</p>
                            <div>
                                <div>
                                    <textarea cols="30" rows="10">Le contenu du textarea lorem ipsum</textarea>

                                    <pre>
                <code>
                <AceEditor
                    fontSize={16}
                    showPrintMargin={false}
                    showGutter= {true}
                    mode="html"
                    theme="monokai"
                    value={`<textarea cols="30" rows="10">Le contenu du textarea lorem ipsum</textarea>`}
                    height={calcHeight(1)}
                    width="100%"
                  />
                </code>
                </pre>



                                    <ul class="coursForm">
                                        <li><strong class="highlight">cols</strong> indique le nombre de colonne à
                                            afficher par défaut</li>
                                        <li><strong class="highlight">rows</strong> indique le nombre de ligne à
                                            afficher par défaut</li>
                                        <li>VOIR SI ON PEUT SECURISE INJECTION SQL</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        



                        <div class="border">
                            <p>input[type="checkbox"]</p>
                            <div>
                                <div>
                                    <input type="checkbox" name="checkbox1" id="checkbox1" checked /><label
                                        for="checkbox1">checkbox 1</label><br />
                                    <input type="checkbox" name="checkbox2" id="checkbox2" /><label
                                        for="checkbox2">checkbox 2</label><br />
                                    <input type="checkbox" name="checkbox3" id="checkbox3" /><label
                                        for="checkbox3">checkbox 3</label><br />
                                    <input type="checkbox" name="checkbox4" id="checkbox4" /><label
                                        for="checkbox4">checkbox 4</label>

                                    
                                    <pre>
                <code>
                <AceEditor
                    fontSize={16}
                    showPrintMargin={false}
                    showGutter= {true}
                    mode="html"
                    theme="monokai"
                    value={`<input type="checkbox" name="checkbox1" id="checkbox1" checked/><label for="checkbox1">checkbox 1</label>`}
                    height={calcHeight(1)}
                    width="100%"
                  />
                </code>
                </pre>


                                    <ul class="coursForm">
                                        <li><strong class="highlight">checked</strong> pour cocher l'élement par défaut
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>



                        <div class="border">
                            <p>input [type="radio"]</p>
                            <div>
                                <div>
                                    <input type="radio" name="age" value="radio1" id="radio1" /><label
                                        for="radio1">Radio 1</label><br />
                                    <input type="radio" name="age" value="radio2" id="radio2" checked /><label
                                        for="radio2">Radio 2</label><br />
                                    <input type="radio" name="age" value="radio3" id="radio3" /><label
                                        for="radio3">Radio 3</label><br />
                                    <input type="radio" name="age" value="radio4" id="radio4" /><label
                                        for="radio4">Radio 4</label>
                                
                                



                                    <pre>
                <code>
                <AceEditor
                    fontSize={16}
                    showPrintMargin={false}
                    showGutter= {true}
                    mode="html"
                    theme="monokai"
                    value={`<input type="radio" name="age" value="radio1" id="radio1"/><label for="radio1">Radio 1</label>`}
                    height={calcHeight(1)}
                    width="100%"
                  />
                </code>
                </pre>



                                    <ul class="coursForm">
                                        <li><strong class="highlight">checked</strong> pour cocher l'élement par défaut
                                        </li>
                                        <li>Même <strong class="highlight">name</strong> à ajouter pour grouper les
                                            buttons radios</li>
                                    </ul>
                                </div>
                            </div>
                        </div>





                        <div class="border">
                            <p>select</p>
                            <div>
                                <div>
                                    <label for="select">Dans quel pays habitez-vous ?</label><br />
                                    <select name="select" id="select">
                                        <option value="" disabled selected>Sélectionner une option</option>
                                        <optgroup label="Optgroup">
                                            <option value="choice1">Choice 1</option>
                                            <option value="choice2">Choice 2</option>
                                            <option value="choice3">Choice 3</option>
                                            <option value="choice4">Choice 4</option>
                                        </optgroup>
                                        <optgroup label="Optgroup">
                                            <option value="choice5">Choice 5</option>
                                            <option value="choice6">Choice 6</option>
                                        </optgroup>
                                        <optgroup label="Optgroup">
                                            <option value="choice7">Choice 7</option>
                                            <option value="choice8">Choice 8</option>
                                        </optgroup>
                                    </select>

                                    
                                    
                                    <pre>
                <code>
                <AceEditor
                    fontSize={16}
                    showPrintMargin={false}
                    showGutter= {true}
                    mode="html"
                    theme="monokai"
                    value={`<label for="select">Dans quel pays habitez-vous ?</label><br />
<select name="select" id="select">
    <option value="" disabled selected>Sélectionner une option</option>
    <optgroup label="Optgroup">
        <option value="choice1">Choice 1</option>
        <option value="choice2">Choice 2</option>
        <option value="choice3">Choice 3</option>
        <option value="choice4">Choice 4</option>
    </optgroup>
    <optgroup label="Optgroup">
        <option value="choice5">Choice 5</option>
        <option value="choice6">Choice 6</option>
    </optgroup>
    <optgroup label="Optgroup">
        <option value="choice7">Choice 7</option>
        <option value="choice8">Choice 8</option>
    </optgroup>
</select>`}
                    height={calcHeight(18)}
                    width="100%"
                  />
                </code>
                </pre>
                                    <ul class="coursForm">
                                        <li><strong class="highlight">selected + disabled</strong> équivalent au placeholder pour les inputs</li>
                                        <li><strong class="highlight">optgroup</strong> pour assembler des élements</li>
                                    </ul>
                                </div>
                            </div>
                        </div>





                        <div class="border">
                            <p>Autres inputs</p>
                            <div>
                                <div>
                                    <label for="email">Input de type email</label> :
                                    <input type="email" id="email" required /><br/>
                                    <hr/>
                                    <label for="url">Input de type url</label> :
                                    <input type="url" id="url" required /><br/>
                                    <hr/>
                                    <label for="tel">Input de type tel</label> :
                                    <input type="tel" id="tel" required /><br/>
                                    <hr/>
                                    <label for="tel">Input de type tel</label> :
                                    <input type="tel" id="tel" required /><br/>
                                    <hr/>
                                    <label for="number">Input de type number</label> :
                                    <input type="number" id="number" min="5" max="20" step="2" required /><br/>
                                    <ul class="coursForm">
                                        <li><strong class="highlight">min</strong> valeur minimale autorisée</li>
                                        <li><strong class="highlight">max</strong> valeur maximale autorisée</li>
                                        <li><strong class="highlight">step</strong> c'est le « pas » de déplacement. Si vous indiquez un pas de 2, le champ n'acceptera que des valeurs de 2 en 2 (par exemple 0, 2, 4, 6…)</li>
                                    </ul>
                                    <hr/>
                                    <label for="range">Input de type curseur</label> :
                                    <input type="range" id="range" min="0" max="20" step="5" required /><br/>
                                    <ul class="coursForm">
                                        <li><strong class="highlight">min</strong> valeur minimale autorisée</li>
                                        <li><strong class="highlight">max</strong> valeur maximale autorisée</li>
                                        <li><strong class="highlight">step</strong> c'est le « pas » de déplacement. Si vous indiquez un pas de 2, le champ n'acceptera que des valeurs de 2 en 2 (par exemple 0, 2, 4, 6…)</li>
                                    </ul>
                                    <hr/>
                                    <label for="color">Input de type color</label> :
                                    <input type="color" id="color" required /><br/>
                                    <hr/>
                                    <label for="date">Input de type date</label> :
                                    <input type="date" id="date" required /><br/>
                                    <ul class="coursForm">
                                        <li><strong class="highlight">date</strong> : pour la date (05/08/1985 par exemple) ;</li>
                                        <li><strong class="highlight">time</strong> : pour l'heure (13:37 par exemple) ;</li>
                                        <li><strong class="highlight">week</strong> : pour la semaine ;</li>
                                        <li><strong class="highlight">month</strong> : pour le mois ;</li>
                                        <li><strong class="highlight">datetime</strong> : pour la date et l'heure (avec gestion du décalage horaire) ;</li>
                                        <li><strong class="highlight">datetime-local</strong> pour la date et l'heure (sans gestion du décalage horaire).</li>
                                    </ul>
                                    <hr/>
                                    <label for="search">Input de type search</label> :
                                    <input type="search" id="search" required /><br/>


<pre>
                <code>
                <AceEditor
                    fontSize={16}
                    showPrintMargin={false}
                    showGutter= {true}
                    mode="html"
                    theme="monokai"
                    value={`<input type="range" id="range" min="0" max="20" step="5" required />`}
                    height={calcHeight(1)}
                    width="100%"
                  />
                </code>
                </pre>



                                </div>
                            </div>
                        </div>



                        <div class="border">
                            <p>Buttons</p>
                            <div>
                                <div>
                                    <input type="submit" value="button de type submit" />
                                    <p>Le principal bouton d'envoi de formulaire. C'est celui que vous utiliserez le plus souvent. Le visiteur sera conduit à la page indiquée dans l'attribut action  du formulaire</p><br/>
                                    <input type="reset" value="button de type reset" />
                                    <p>Remise à zéro du formulaire</p><br/>
                                    <input type="image" value="button de type image" src="image.jpg"/>
                                    <p>Equivalent du bouton submit  , présenté cette fois sous forme d'image. Rajoutez l'attribut src  pour indiquer l'URL de l'image</p><br/>
                                    <input type="button" value="button de type button" />
                                    <p>bouton générique, qui n'aura (par défaut) aucun effet. En général, ce bouton est géré en JavaScript pour exécuter des actions sur la page. Nous ne l'utiliserons pas ici.</p>
                                    
                   <pre>               
                <code>
                <AceEditor
                    fontSize={16}
                    showPrintMargin={false}
                    showGutter= {true}
                    mode="html"
                    theme="monokai"
                    value={`<input type="submit" value="button de type submit" />
<input type="submit" value="button de type submit" />
<input type="reset" value="button de type submit" />
<input type="image" value="button de type submit" src="image.jpg" />
<input type="button" value="button de type submit" />`}
                    height={calcHeight(5)}
                    width="100%"
                  />
                </code>
                </pre>

</div>
</div>
</div>

</form>



      </div>
    )
}
